<template>
  <div class="card">
    <div class="card-body">
      <div class="rfid-head">
        <div>
          <div class="rfid-title">{{ $t("menuitems.clouds.nfcreader.rfid.title") }}</div>
          <p class="mb-2">{{ $t("menuitems.clouds.nfcreader.rfid.standardFlow") }}</p>
          <p class="text-muted mb-0">{{ $t("menuitems.clouds.nfcreader.rfid.extendedFlow") }}</p>
        </div>
        <el-tag v-if="!ready" type="info" size="small">{{ $t("menuitems.clouds.nfcreader.rfid.needDevice") }}</el-tag>
        <el-tag v-else type="success" size="small">{{ $t("menuitems.clouds.nfcreader.rfid.scan") }}</el-tag>
      </div>
      <p v-if="lastUid" class="rfid-uid mb-0">{{ $t("menuitems.clouds.nfcreader.rfid.lastUid") }}：{{ lastUid }}</p>
    </div>
  </div>
</template>

<script>
import { parseUidLine } from "@/utils/rfidProtocol";

export default {
  name: "RfidDevicePanel",
  props: {
    online: { type: Boolean, default: false },
    connected: { type: Boolean, default: false },
  },
  data() {
    return {
      lastUid: "",
    };
  },
  computed: {
    ready() {
      return this.online && this.connected;
    },
  },
  created() {
    this.$bus.$on("rfid-line", this.onDeviceLine);
  },
  beforeDestroy() {
    this.$bus.$off("rfid-line", this.onDeviceLine);
  },
  methods: {
    onDeviceLine(line) {
      const uid = parseUidLine(line);
      if (uid) this.lastUid = uid.uid;
    },
  },
};
</script>

<style scoped>
.rfid-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}
.rfid-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
.rfid-uid {
  margin-top: 12px;
  color: #74788d;
}
</style>
